module.exports = __webpack_public_path__ + "media/images/bus/conditions/AAFR-04d1a023a4d4db6c8f101ded0dfdca86.svg";